export class DonationProgramStatus {
    public static ACTIVE = 'ACTIVE';
    public static INACTIVE = 'INACTIVE';
}
